import { PhoneNumberUtil } from "google-libphonenumber";
import * as yup from "yup";
const phoneUtil = PhoneNumberUtil.getInstance();
export const createAccount = yup.object({
  name: yup.string().required(" Name is required"),
  parent: yup.string().required("Account is required"),
  contact_number: yup
    .string()
    .nullable()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value || value.trim() === "" || /^\+\d{1,4}$/.test(value.trim())) {
        return true;
      }
      try {
        const parsed = phoneUtil.parseAndKeepRawInput(value, "NP");
        return phoneUtil.isValidNumber(parsed);
      } catch (err) {
        return false;
      }
    }),
  opening_balance: yup
    .string()
    .nullable()
    .optional()
    .transform((value, originalValue) => {
      if (originalValue === null || originalValue === "") return "0";
      return originalValue;
    }),
});

export const createAccountInfovalidation = yup.object({
  name: yup.string().required(" Name is required"),
  vat_pan: yup.string().optional().nullable(),
  address: yup.string().required("Company address is required"),
  contact_number: yup
    .string()
    .nullable()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value || value.trim() === "" || /^\+\d{1,4}$/.test(value.trim())) {
        return true;
      }
      try {
        const parsed = phoneUtil.parseAndKeepRawInput(value, "NP");
        return phoneUtil.isValidNumber(parsed);
      } catch (err) {
        return false;
      }
    }),
  opening_balance: yup
    .string()
    .nullable()
    .optional()
    .transform((value, originalValue) => {
      if (originalValue === null || originalValue === "") return "0";
      return originalValue;
    }),
  parent: yup.string().required("Ledger Group is required"),
});
